import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import {getDepartment, getDivision, getNationality, getPosition, getReligion, getReportTo, getDocumentSubType, getUserData, getCostCenter, getUniformSizes, getNotification, bulkNotificationChange, getCurrentApprovers} from "api/services/common"


export const fetchDivision = createAsyncThunk("fetchDivision", async () => {
    const res = await getDivision();
    // console.log(res, "ressss")
    return res?.data
 });

 export const fetchPosition = createAsyncThunk("fetchPosition", async () => {
    const res = await getPosition();
    // console.log(res, "ressss")
    return res?.data
 });

 export const fetchNationality = createAsyncThunk("fetchNationality", async () => {
    const res = await getNationality();
    // console.log(res, "ressss")
    return res?.data
 });

 export const fetchDepartment = createAsyncThunk("fetchDepartment", async () => {
    const res = await getDepartment();
    // console.log(res, "ressss")
    return res?.data
 });

 export const fetchReligion = createAsyncThunk("fetchReligion", async () => {
    const res = await getReligion();
    // console.log(res, "ressss")
    return res?.data
 });


 export const fetchReportTo = createAsyncThunk("fetchReportTo", async () => {
    const res = await getReportTo();
    // console.log(res, "ressss")
    return res?.data
 });

 export const fetchDocumentSubType = createAsyncThunk("fetchDocumentSubType", async () => {
   const res = await getDocumentSubType();
   // console.log(res, "ressss")
   return res?.data
});

export const fetchUserData = createAsyncThunk("fetchUserData", async () => {
   const res = await getUserData();
   //console.log(res, "ressss")
   return res?.data
});

export const fetchCostCenterData = createAsyncThunk("fetchCostCenterData", async () => {
   const res = await getCostCenter();
   //console.log(res, "ressss")
   return res?.data
});


export const fetchUniformSizesData = createAsyncThunk("fetchUniformSizesData", async () => {
   const res = await getUniformSizes();
   return res?.data
});


export const fetchCurrentApproversData = createAsyncThunk("fetchCurrentApproversData", async () => {
   const res = await getCurrentApprovers();
   return res?.data
});


export const fetchNotificationData = createAsyncThunk("fetchNotificationData", async (params) => {
   const res = await getNotification(params);

   return res?.data
});


export const bulkNotificationChangeHandle = createAsyncThunk("bulkNotificationChangeHandle", async (params, { dispatch, getState }) => {
   const res = await bulkNotificationChange(params);
   dispatch(fetchNotificationData(params))

   return params
});


export const commonSlice = createSlice({
    name: "common",
    initialState: {
     divisionLoading: false,
     division: [],
     divisionError: false,

     positionLoading: false,
     position: [],
     positionError: false,

     nationalityLoading: false,
     nationality: [],
     nationalityError: false,

     departmentLoading: false,
     department: [],
     departmentError: false,

     religionLoading: false,
     religion: [],
     religionError: false,

     reportToLoading: false,
     reportTo: [],
     reportToError: false,

     documentSubTypeLoading: false,
     documentSubType:[],
     documentSubTypeError:false,

     userDataLoading: false,
     userData:[],
     userDataError:false,


     costCenterLoading: false,
     costCenter:[],
     costCenterError:false,


     uniformSizesLoading: false,
     uniformSizes:[],
     uniformSizesError:false,


     currentApproversLoading: false,
     currentApprovers:[],
     currentApproversError:false,


     notificationLoading: false,
     notifications:[],
     notificationError:false,
     notificationCount:0,



     showToast: false,
     toastTitle: "",
     toastHeading: "",
     toastSubheading: "",
     toastType: "",

     
    },
    extraReducers: (builder) => {
     builder.addCase(fetchDivision.pending, (state, action) => {
      state.divisionLoading = true;
     })
     builder.addCase(fetchDivision.fulfilled, (state, {payload}) => {
      state.divisionLoading = false;
      state.division = payload.results;
     })
     builder.addCase(fetchDivision.rejected, (state, action) => {
      state.divisionError = true;
     })



     builder.addCase(fetchPosition.pending, (state, action) => {
        state.positionLoading = true;
       })
       builder.addCase(fetchPosition.fulfilled, (state, {payload}) => {
        state.positionLoading = false;
        state.position = payload.results;
       })
       builder.addCase(fetchPosition.rejected, (state, action) => {
        state.positionError = true;
       })




     builder.addCase(fetchNationality.pending, (state, action) => {
        state.nationalityLoading = true;
       })
       builder.addCase(fetchNationality.fulfilled, (state, {payload}) => {
        state.nationalityLoading = false;
        state.nationality = payload;
       })
       builder.addCase(fetchNationality.rejected, (state, action) => {
        state.nationalityError = true;
       })



       builder.addCase(fetchDepartment.pending, (state, {payload}) => {
        // console.log(payload, "ACTIONNNNN")

        state.departmentLoading = true;
       })
       builder.addCase(fetchDepartment.fulfilled, (state, {payload}) => {
        state.departmentLoading = false;
        state.department = payload.results;
       })
       builder.addCase(fetchDepartment.rejected, (state, {payload}) => {
        state.departmentError = true;
       })



       builder.addCase(fetchReligion.pending, (state, action) => {
        state.religionLoading = true;
       })
       builder.addCase(fetchReligion.fulfilled, (state, {payload}) => {
        state.religionLoading = false;
        state.religion = payload.results;
       })
       builder.addCase(fetchReligion.rejected, (state, action) => {
        state.religionError = true;
       })


       builder.addCase(fetchReportTo.pending, (state, action) => {
        state.reportToLoading = true;
       })
       builder.addCase(fetchReportTo.fulfilled, (state, {payload}) => {
        state.reportToLoading = false;
        state.reportTo = payload;
       })
       builder.addCase(fetchReportTo.rejected, (state, action) => {
        state.reportToError = true;
       })


       builder.addCase(fetchDocumentSubType.pending, (state, action) => {
         state.documentSubTypeLoading = true;
        })
        builder.addCase(fetchDocumentSubType.fulfilled, (state, {payload}) => {
         state.documentSubTypeLoading = false;
         state.documentSubType = payload;
        })
        builder.addCase(fetchDocumentSubType.rejected, (state, action) => {
         state.documentSubTypeError = true;
        })


        builder.addCase(fetchUserData.pending, (state, action) => {
         state.userDataLoading = true;
        })
        builder.addCase(fetchUserData.fulfilled, (state, {payload}) => {
         state.userDataLoading = false;
         console.log(payload, "payload")
         state.userData = payload;
        })
        builder.addCase(fetchUserData.rejected, (state, action) => {
         state.userDataError = true;
        })



        builder.addCase(fetchCostCenterData.pending, (state, action) => {
         state.costCenterLoading = true;
        })
        builder.addCase(fetchCostCenterData.fulfilled, (state, {payload}) => {
         state.costCenterLoading = false;
         state.costCenter = payload.results;
        })
        builder.addCase(fetchCostCenterData.rejected, (state, action) => {
         state.costCenterError = true;
        })


        builder.addCase(fetchUniformSizesData.pending, (state, action) => {
         state.uniformSizesLoading = true;
        })
        builder.addCase(fetchUniformSizesData.fulfilled, (state, {payload}) => {
         state.uniformSizesLoading = false;
         state.uniformSizes = payload.results;
        })
        builder.addCase(fetchUniformSizesData.rejected, (state, action) => {
         state.uniformSizesError = true;
        })


        builder.addCase(fetchCurrentApproversData.pending, (state, action) => {
         state.currentApproversLoading = true;
        })
        builder.addCase(fetchCurrentApproversData.fulfilled, (state, {payload}) => {
         state.currentApproversLoading = false;
         // endpoint returns a plain array, not a paginated { results } object
         state.currentApprovers = payload || [];
        })
        builder.addCase(fetchCurrentApproversData.rejected, (state, action) => {
         state.currentApproversError = true;
        })



        builder.addCase(fetchNotificationData.pending, (state, action) => {
         state.notificationLoading = true;
        })
        builder.addCase(fetchNotificationData.fulfilled, (state, {payload}) => {
         // console.log(payload.count, "payload")
         state.notificationLoading = false;
         if(payload.previous){
            state.notifications = [...payload.results, ...state.notifications];
         }else{
            state.notifications = payload.results;
         }
         state.notificationCount = payload.count
        })
        builder.addCase(fetchNotificationData.rejected, (state, action) => {
         state.notificationError = true;
        })


        builder.addCase(bulkNotificationChangeHandle.pending, (state, action) => {
         state.notificationLoading = true;
        })
        builder.addCase(bulkNotificationChangeHandle.fulfilled, (state, action) => {
         state.notificationLoading = false;
         // action.meta.arg.dispatch(fetchNotificationData({is_read: action?.is_read}));
         // if(payload?.action !== "read"){
         //    state.notifications = [];
         // }
        })
        builder.addCase(bulkNotificationChangeHandle.rejected, (state, action) => {
         state.notificationError = true;
         state.notificationLoading = false;
        

        })



    },
    reducers: {
        handleToast: (state, { payload: {showToast, toastTitle, toastHeading, toastSubheading, toastType} }) => {
            console.log("HHEEEEREEEEEEEEEEEE", showToast, toastTitle, toastHeading, toastSubheading, toastType)
            state.showToast = showToast
            state.toastTitle= toastTitle
            state.toastHeading= toastHeading
            state.toastSubheading = toastSubheading
            state.toastType = toastType

          },
          handleNotifications: (state, { payload }) => {
            console.log(payload, "JJJJ")
            state.notifications = [payload, ...state.notifications]

          }
      },
});

export const { handleToast, handleNotifications } = commonSlice.actions

export default commonSlice.reducer;
